// import the library
import { library } from "@fortawesome/fontawesome-svg-core";

// import your icons
import { far } from "@fortawesome/pro-regular-svg-icons";
import {
	faBars as faBarsSolid,
	faBinoculars as faBinocularsSolid,
	faCamera as faCameraSolid,
	faCloudUpload as faCloudUploadSolid,
	faCommentCheck as faCommentCheckSolid,
	faExclamationTriangle as faExclamationTriangleSolid,
	faEye as faEyeSolid,
	faCheckSquare as faCheckSquareSolid,
	faCircle as faCircleSolid,
	faFastForward as faFastForwardSolid,
	faImage as faImageSolid,
	faStepForward as faStepForwardSolid,
	faUpload as faUploadSolid,
	faVolumeUp as faVolumeUpSolid	
} from "@fortawesome/pro-solid-svg-icons";

let iconsArray = [	
	far,
	faBarsSolid,
	faBinocularsSolid,
	faCameraSolid,
	faCheckSquareSolid,
	faCircleSolid,
	faCloudUploadSolid,
	faCommentCheckSolid,
	faExclamationTriangleSolid,
	faEyeSolid,
	faFastForwardSolid,
	faImageSolid,
	faStepForwardSolid,
	faUploadSolid,
	faVolumeUpSolid
];

library.add(	
	...iconsArray
);

export const icons = iconsArray;